import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl } from '@angular/forms';
import { NotifierService } from 'angular-notifier';

import { AttachmentType } from '@core/models/attachment-type';
import { CarouselData } from '@core/models/carousel-data';
import { FileService } from '@core/services/file.service';
import { UserConfirmationComponent } from '../user-confirmation/user-confirmation.component';
import { FileTypeSelectionComponent } from '../file-type-selection/file-type-selection.component';
import { UserService } from '@core/services/user.service';
import { User } from '@core/models/user';

@Component({
	selector: 'app-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

	user: User;
	@Input() attachmentTypes: AttachmentType[];

	maxFileSize: number = 10485760; //10 * 1024 * 1024; 10MB
	fileControl = new FormControl();

	constructor(
		private modalService: NgbModal,
		public fileService: FileService,
		private userService: UserService,
		private notifierService: NotifierService) {

		this.user = userService.getUser();
	}

	ngOnInit(): void {
	}

	onFileSelect(files: FileList) {

		let file = files[0];

		if (file == null || file == undefined) { return };

		const modalRef = this.modalService.open(FileTypeSelectionComponent, {
			windowClass: '',
			keyboard: false,
			backdrop: 'static',
			centered: true,
		});

		let fileTypeSelectionComponent = modalRef.componentInstance as FileTypeSelectionComponent;
		fileTypeSelectionComponent.attachmentTypes = this.attachmentTypes;

		modalRef.result.then(async (confirmed: boolean) => {

			if (confirmed) {

				if (!this.fileIsValid(file)) {

					this.notifierService.notify('error', `Het bestand '${file.name}' mag niet groter zijn dan 10MB.`);
				}
				else {

					const carouselData = new CarouselData();
					carouselData.src = await this.readFile(file);
					carouselData.file = file;
					carouselData.fileType = fileTypeSelectionComponent.attachmentType.value;
					carouselData.id = this.fileService.fileCarousel.length + 1;

					this.fileService.addFile(carouselData);
					this.fileControl.reset();
				}
			}

		}, () => { });
	}

	fileIsValid(file: File): boolean {

		return file.size <= this.maxFileSize;
	}

	deleteFile(carouselData: CarouselData) {

		const modalRef = this.modalService.open(UserConfirmationComponent, {
			windowClass: '',
			keyboard: false,
			backdrop: 'static',
			centered: true
		});

		let userConfirmationComponent = modalRef.componentInstance as UserConfirmationComponent;
		userConfirmationComponent.title = 'Bestand verwijderen';
		userConfirmationComponent.bodyText = `Weet u zeker dat u bestand '${carouselData.file.name}' wilt verwijderen?`;

		modalRef.result.then((confirmed: boolean) => {

			if (confirmed) {

				this.fileService.deleteFile(carouselData.id);
			}

		}, () => { });
	}

	private readFile(file: File): Promise<string | ArrayBuffer> {

		return new Promise((resolve, reject) => {

			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {

				resolve(reader.result);
			};
			reader.onerror = () => {

				reject(reader.error);
			};
		});
	}
}
